import { gql } from "@apollo/client";

export const updateLibraryCategory = gql`
  mutation updateLibraryCategory($_id: MongoID!, $record: UpdateByIdLibraryCategoryInput!) {
    libraryCategory_UpdateById(_id :$_id, record: $record) {
      record {
        _id
      }
    }
  }
`;
